import {
  AssetGroupAdapter,
  type AssetGroupAdapterType,
  type AssetTypeType,
  DeviceAdapter,
  type DeviceAdapterType,
  EquipmentAdapter,
  type EquipmentAdapterType,
  FacilityAdapter,
  type FacilityAdapterType,
  FlowAdapter,
  type FlowAdapterType,
  type FormAdapterType,
  FormSchemaAdapter,
  FormSubmissionAdapter,
  type FormSubmissionServiceType,
  ResourceLookup,
  type ResourceLookupType,
  Resources,
} from "@validereinc/domain";
import { Assets } from "@validereinc/domain-controllers";

const { AssetTypeSelection } = Assets.view;

export const getResourceAdapterAndResource = (
  resourceType: AssetTypeType | ResourceLookupType
): {
  adapter:
    | FacilityAdapterType
    | FlowAdapterType
    | AssetGroupAdapterType
    | EquipmentAdapterType
    | DeviceAdapterType
    | FormAdapterType
    | FormSubmissionServiceType;
  resource: string;
} => {
  switch (resourceType) {
    case ResourceLookup.FLOW:
    case AssetTypeSelection.FLOW:
      return {
        adapter: FlowAdapter,
        resource: Resources.FLOW,
      };
    case ResourceLookup.ASSET_GROUP:
    case AssetTypeSelection.ASSET_GROUP:
      return {
        adapter: AssetGroupAdapter,
        resource: Resources.ASSET_GROUP,
      };
    case ResourceLookup.EQUIPMENT:
    case AssetTypeSelection.EQUIPMENT:
      return {
        adapter: EquipmentAdapter,
        resource: Resources.EQUIPMENT,
      };
    case ResourceLookup.DEVICE:
    case AssetTypeSelection.DEVICE:
      return {
        adapter: DeviceAdapter,
        resource: Resources.DEVICE,
      };
    case AssetTypeSelection.FACILITY:
    case ResourceLookup.FACILITY:
      return {
        adapter: FacilityAdapter,
        resource: Resources.FACILITY,
      };
    case ResourceLookup.FORM_SCHEMA:
      return {
        adapter: FormSchemaAdapter,
        resource: Resources.FORM_SCHEMA,
      };
    case ResourceLookup.FORM_SUBMISSION:
      return {
        adapter: FormSubmissionAdapter,
        resource: Resources.FORM_SUBMISSION,
      };
  }
};
